import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {PrintOptions} from '../../common/components/buttons/print-options.helper';
import {InitialContactDto} from '@sidr/dto-types';
import {Level, ToastService} from '../../services/toast.service';
import {StudentService} from '../../services/student.service';

@Component({
  selector: `initial-contact`,
  templateUrl: 'initialContact.component.html'
})
export class InitialContactComponent implements OnChanges {
  @Input() printOptions: PrintOptions;
  @Input() districtId: string;
  @Input() studentId: string;
  concern: string[] = ['N/A', 'Yes', 'No'];
  loading: boolean;
  initial: InitialContactDto;
  NotificationTitle = 'Parent/Guardian Notification Process';

  constructor(private studentService: StudentService, private toastService: ToastService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getData();
  }

  sanitizeInitial() {
    this.initial = this.initial || {
      parent_notified: '',
      policies_given: '',
      written_notice: '',
      communicator: '',
      share_concern: ''
    };
  }

  getData() {
    if (!this.districtId || !this.studentId) {
      return;
    }
    this.loading = true;
    this.studentService.getInitialContact(this.districtId, this.studentId).subscribe(resp => {
      this.initial = resp;
      this.sanitizeInitial();
    }, error => {
      this.toastService.AddNotification(Level.ERROR, this.NotificationTitle, 'Error getting data');
    }, () => {
      this.loading = false;
    });
  }

  save() {
    if (!this.initial.written_notice || this.initial.written_notice.length === 0) {
      delete this.initial.written_notice;
    }
    if (!this.initial.policies_given || this.initial.policies_given.length === 0) {
      delete this.initial.policies_given;
    }
    if (!this.initial.parent_notified || this.initial.parent_notified.length === 0) {
      delete this.initial.parent_notified;
    }
    this.loading = true;
    this.studentService.patchInitialContact(this.districtId, this.studentId, this.initial).subscribe(resp => {
      this.toastService.AddNotification(Level.SUCCESS, this.NotificationTitle, 'Saved Initial Contact');
      this.getData();
    }, err => {
      this.toastService.AddNotification(Level.ERROR, this.NotificationTitle, 'Error saving data');
    }, () => {
      this.loading = false;
    });
  }

  selectInitialStaff(whom: any) {
    this.initial.communicator = whom;
  }
}
